import { z } from 'zod';

export const crmCoverageSearchSchema = z.object({
  ticketSource: z.enum(['move', 'bubble', 'both']).optional(),
  coverageView: z.enum(['users', 'issues', 'tickets']).optional(),
  section: z.literal('accounts-without-profiles').optional(),
  q: z.string().trim().max(200).optional(),
  page: z.coerce.number().int().positive().max(100_000).optional(),
  accountId: z.uuid().optional(),
});
export type CrmCoverageSearch = z.infer<typeof crmCoverageSearchSchema>;

export function getCoverageAccountSelectionQuery(accountId: string) {
  return { profileLinkage: 'without' as const, q: accountId, page: 1, pageSize: 1 };
}

export function getCoverageProfilesDrilldown() {
  return { accountLinkage: 'without' as const, page: 1 };
}
